export default "__VITE_ASSET__xuIQmNxg__"